import React from 'react';
import { Accordion } from '../../../components';

import { SnippetConfiguration, SnippetDataDictionary } from '../../../services/dataModels';
import { DataRow } from './DataRow';

interface InstructionSnippetProps {
  path: string;
  configuration: SnippetConfiguration;
  data: SnippetDataDictionary[];
}

const InstructionSnippet = ({ path, configuration, data }: InstructionSnippetProps) => {
  return (
    <>
      {data.map((r, i) => (
        <Accordion
          key={i}
          size={configuration.columns.length}
          title={r[configuration.rowTitleKey] as string}>
          <DataRow
            path={`${path}.rowData[${i}]`}
            configuration={configuration.columns}
            data={r}
            disabled={Object.keys(r)}
          />
        </Accordion>
      ))}
    </>
  );
};

export default InstructionSnippet;
